import axios from "axios";

export interface TicketSummary {
    id: string;
    name: string;
    voucherKey: string;
    redeemed: boolean;
    notified: boolean;
    code?: string;
    campaignId?: string;
    campaignKey?: string;
    campaignName?: string;
}

const mapTicket = (ticket: any): TicketSummary => {
    const campaign = ticket?.campaign ?? ticket?.Campaign;
    return {
        id: ticket?.id ?? ticket?.ID ?? "",
        name: ticket?.name ?? ticket?.Name ?? ticket?.Data?.ReceiverName ?? "Ticket",
        voucherKey: ticket?.voucherKey ?? ticket?.VoucherKey ?? "",
        redeemed: ticket?.redeemed ?? ticket?.Redeemed ?? false,
        notified: ticket?.notified ?? ticket?.Notified ?? false,
        code: ticket?.code ?? ticket?.Code ?? undefined,
        campaignId: ticket?.campaignId ?? ticket?.campaignID ?? ticket?.CampaignID ?? campaign?.id ?? campaign?.ID ?? undefined,
        campaignKey: ticket?.campaignKey ?? ticket?.CampaignKey ?? campaign?.key ?? campaign?.Key ?? undefined,
        campaignName: campaign?.name ?? campaign?.Name ?? undefined,
    };
};

export const fetchUserTickets = async (accessToken: string, campaignId: string): Promise<TicketSummary[]> => {
    const response = await axios.get(`${ShopServer}/api/vouchers/GetMyVouchers`, {
        params: { campaignID: campaignId },
        headers: {
            Authorization: `IdentityBearer ${accessToken}`,
        },
    });

    const payload = response.data.result.value;
    const tickets = Array.isArray(payload) ? payload : payload?.tickets ?? payload?.Tickets ?? [];

    return tickets.map(mapTicket);
};

export const fetchTicketsByEmail = async (email: string, accessToken: string, campaignId: string): Promise<TicketSummary[]> => {
    if (!email) {
        return Promise.resolve([]);
    }
    const response = await axios.get(`${ShopServer}/api/vouchers/GetVouchersByEmail/${email}`, {
        params: { campaignID: campaignId },
        headers: {
            Authorization: `IdentityBearer ${accessToken}`,
        },
    });

    const payload = response.data.result.value;
    const tickets = Array.isArray(payload) ? payload : payload?.tickets ?? payload?.Tickets ?? [];

    return tickets.map(mapTicket);
};

export const fetchTicketsByCell = async (cell: string, accessToken: string, campaignId: string): Promise<TicketSummary[]> => {
    if (!cell) {
        return Promise.resolve([]);
    }
    const response = await axios.get(`${ShopServer}/api/vouchers/GetVouchersByCell/${cell}`, {
        params: { campaignID: campaignId },
        headers: {
            Authorization: `IdentityBearer ${accessToken}`,
        },
    });

    const payload = response.data.result.value;
    const tickets = Array.isArray(payload) ? payload : payload?.tickets ?? payload?.Tickets ?? [];

    return tickets.map(mapTicket);
};
